<template>
  <div class="home" :class="{ primary: isHome, 'grey lighten-4': !isHome }">
    <div class="home__content">
      <app-navbar :isAdmin="isAdmin" v-if="navbar"/>
      <app-subnavbar v-if="!isHome" :menu="permissions"/>
      <router-view v-if="hasPermissions" :menu="permissions" @navbar="e => navbar = e"/>
      <p class="py-5 text-center" v-if="!isLoading && !hasPermissions">You don't have rights</p>
      <div class="py-5 text-center" v-if="isLoading && !hasPermissions">
        <v-progress-circular
          :color="isHome ? 'white' : 'primary'"
          indeterminate
        ></v-progress-circular>
      </div>
    </div>

    <app-footer :home="isHome"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getBrowserLang } from '@/helpers';
import { Storage } from '@/utils';
import { Permission, User } from '@/api';
import log from '@/helpers/logger';
import lang from '@/lang';

// [Notes]
// This function could be used with any promise, for now it's only used here but
// it could be used somewhere else, if it's the case move this function to another
// file like helpers or utils and import it wherever you want.
const wait = p => p.then(r => [r]).catch(r => [undefined, r]);

export default {
  name: 'app-home',
  data() {
    return {
      navbar: true,
      isLoading: true,
      isAdmin: false,
      permissions: [],
    };
  },
  watch: {
    $route: {
      handler() {
        this.metadata();
      },
    },
  },
  computed: {
    ...mapState([
      'User',
    ]),
    isHome() {
      return this.$route.name === 'menu.index';
    },
    menuId() {
      return this.$route.params.id;
    },
    hasPermissions() {
      return !!this.permissions.length;
    },
    current() {
      return (this.permissions.find(p => p.menu.guid === this.menuId) || {}).menu || {};
    },
  },
  methods: {
    metadata() {
      const info = this.path(this.current).map(i => i.titleEN || i.titleFR).join(' - ');
      const geodis = this.User.email.includes('geodis.com');
      this.navbar = true;

      log.info('[Home] User has entered', info || 'Home');

      window.gtag('event', 'page_view', {
        page_title: info || 'Home',
        page_location: window.location.href,
        page_path: window.location.pathname,
      });

      window.dataLayer.push({
        Branche: geodis ? 'GEODIS' : 'EXTERIEUR',
      });
    },
    path(item, hold = []) {
      hold.unshift(item);

      if (item.parent) {
        return this.path(item.parent, hold);
      }

      return hold;
    },
  },
  async created() {
    const [{ data: permission }] = await wait(Permission.me(this.User.email));
    const [{ data: geodisLogin } = {}] = await wait(User.geodisLogin({ email: this.User.email }));
    let [{ data: permissionGroup }] = await wait(Permission.group(this.User.email, { low: true }));

    log.info('[Home] User online');
    // Set language on base of the one that is in the browser fallbacks to english.
    lang.setLang(getBrowserLang());

    if (geodisLogin) {
      Storage.set(this.User.email, btoa(geodisLogin));
    }

    // [Deprecated] this logic is manipulated by the store, not needed here.
    // Auth.me(this.User.email).then(() => {
    //   this.isAdmin = true;
    // });

    permissionGroup = permissionGroup.reduce((acc, item) => {
      // eslint-disable-next-line
      if (item.length) acc = acc.concat(item);
      return acc;
    }, []);

    this.isLoading = false;
    this.permissions = window._
      .chain([])
      .concat(permission, permissionGroup)
      .uniqBy('menuId')
      .value();

    this.metadata();
  },
};
</script>
